/**
 * Get the API base URL for the current environment
 * Uses VITE_API_URL consistently across all environments
 */
export const getApiBaseUrl = (): string => {
  const envApiUrl = import.meta.env.VITE_API_URL;
  
  if (envApiUrl) {
    return envApiUrl;
  }
  
  // Fallback for local development if VITE_API_URL is not set
  const fallbackUrl = 'http://localhost:5001';
  
  console.warn(
    '[getApiBaseUrl] VITE_API_URL environment variable not set. ' +
    `Using fallback: ${fallbackUrl}. Please configure VITE_API_URL in your environment.`
  );
  
  return fallbackUrl;
};

/**
 * Build a full API URL for the given endpoint
 */
export const buildApiUrl = (endpoint: string): string => {
  const baseUrl = getApiBaseUrl();
  
  // Handle both /api/... and api/... formats
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  return `${baseUrl}${cleanEndpoint}`;
}; 